const AdditionalCharges = ({ color }) => {
  return (
    <svg height="1.6vw" viewBox="0 0 30 30" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M15 2C8.373 2 3 7.373 3 14C3 20.627 8.373 26 15 26C21.627 26 27 20.627 27 14C27 7.373 21.627 2 15 2ZM15 24C9.477 24 5 19.523 5 14C5 8.477 9.477 4 15 4C20.523 4 25 8.477 25 14C25 19.523 20.523 24 15 24Z" />
      <path d="M20 13H16V9C16 8.448 15.552 8 15 8C14.448 8 14 8.448 14 9V13H10C9.448 13 9 13.448 9 14C9 14.552 9.448 15 10 15H14V19C14 19.552 14.448 20 15 20C15.552 20 16 19.552 16 19V15H20C20.552 15 21 14.552 21 14C21 13.448 20.552 13 20 13Z" />
      <path d="M15 7C15.552 7 16 6.552 16 6C16 5.448 15.552 5 15 5C14.448 5 14 5.448 14 6C14 6.552 14.448 7 15 7Z" />
      <path d="M15 23C15.552 23 16 22.552 16 22C16 21.448 15.552 21 15 21C14.448 21 14 21.448 14 22C14 22.552 14.448 23 15 23Z" />
      <path d="M6 14C6 14.552 5.552 15 5 15C4.448 15 4 14.552 4 14C4 13.448 4.448 13 5 13C5.552 13 6 13.448 6 14Z" />
      <path d="M25 15C24.448 15 24 14.552 24 14C24 13.448 24.448 13 25 13C25.552 13 26 13.448 26 14C26 14.552 25.552 15 25 15Z" />
    </svg>
  );
};
export default AdditionalCharges;
